export const REACT_APP_ENDPOINT =
  process.env.REACT_APP_ENDPOINT || "http://localhost:3030";

export const ENABLE_REGISTRATION =
  process.env.REACT_APP_ENABLE_REGISTRATION === "true";
